module.exports = __webpack_public_path__ + "8f80f8d9052fd58bdc088595fc737101.fbx";